import catalog from '@/content/browserPlugins.json';

export const BROWSER_PLUGINS = catalog;
export const pluginById = id => catalog.find(plugin => plugin.id === id);
export function filterPlugins(plugins, query) {
  const words = String(query || '').toLowerCase().trim().split(/\s+/).filter(Boolean);
  return plugins.filter(plugin => words.every(word => `${plugin.name} ${plugin.category} ${plugin.description}`.toLowerCase().includes(word)));
}
export function pluginWorkPrompt(id, suggestion) {
  const plugin = pluginById(id);
  if (!plugin) throw new Error('This plugin is unavailable.');
  return `${suggestion || plugin.prompt}\n\nUse the ${plugin.name} browser plugin on my Mac (${plugin.url}). Use my signed-in browser; let me handle sign-in if needed.`;
}
